// How many of the images on the download page are ready.
//
// Counted by looking each image up in the availability map -- NOT by counting
// the map's own true values. The map is keyed per POSE ("pose-<id>"), because
// the server treats a pose as ready only when every deliverable of it exists
// (OrderImageAvailability#availability_map deliberately ANDs the sheets of one
// pose together). The page, though, renders one tile per SHEET, and a customer
// who buys the same pose on two backgrounds gets two tiles sharing one key.
//
// Counting map values against the tile count compared two different things and
// could never agree. Order #478212 has 14 sheets over 11 distinct poses, so the
// banner sat at "11 of 14 images ready" permanently while every file was
// present and downloadable -- a progress bar that never completes, which reads
// to the customer as a broken order.
//
// Lives in utils/ rather than beside the component because a *.test.jsx under
// components/ breaks the production build.
export const countReady = (images, availability) => {
  if (!Array.isArray(images) || !availability) return 0;

  return images.filter((image) => availability[image.itemKey] === true).length;
};

export default countReady;
